import React from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import AVText from './AVText';
import CustomTextInput from './CustomTextInput';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import Styles from '../Styles';
import Localized from 'src/constants/AppStrings';

type AppSurveyFormProps = {
  questions: string[];
  firstAnswer: string;
  secondAnswer: string;
  onChangeFirstAnswer: (text: string) => void;
  onChangeSecondAnswer: (text: string) => void;
};

const RewardsAppSurvey = ({
  questions,
  firstAnswer,
  secondAnswer,
  onChangeFirstAnswer,
  onChangeSecondAnswer,
}: AppSurveyFormProps) => {
  const hasSecondQuestion = questions.length > 1;

  return (
    <View style={styles.appSurveyView}>
      {questions.length >= 1 && (
        <View>
          <AVText
            style={[
              styles.inputLabelText,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
            ]}
          >
            {questions[0]}
          </AVText>

          <CustomTextInput
            autoCapitalize="none"
            accessible={true}
            label={Localized.Labels.rewards_app_survey_label}
            accessibilityLabel={questions[0]}
            accessibilityValue={{text: firstAnswer}}
            aria-label={questions[0]}
            aria-valuetext={firstAnswer}
            value={firstAnswer}
            multiline={true}
            numberOfLines={4}
            onChangeText={onChangeFirstAnswer}
            maxLength={140}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            returnKeyType={hasSecondQuestion ? 'next' : 'done'}
            containerStyle={styles.textContainerStyle}
            contentStyle={styles.msgContentStyle}
            clearButtonMode="while-editing"
            textColor={'#111'}
            fontSize={Styles.Fonts.f8}
            labelStyle={[
              styles.msgLableViewTextStyle,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
            ]}
            outlineStyle={styles.msgLabelOutlineStyle}
            showShadow={Platform.OS === 'ios'}
          />

          <AVText
            style={[
              styles.payDescriptionCountLabel,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
              firstAnswer.length === 140 && {
                color: Styles.Colors.Refive.deleteButton,
              },
            ]}
          >
            {firstAnswer.length + '/140'}
          </AVText>
        </View>
      )}

      {hasSecondQuestion && (
        <View>
          <AVText
            style={[
              styles.inputLabelText,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
            ]}
          >
            {questions[1]}
          </AVText>

          <CustomTextInput
            autoCapitalize="none"
            accessible={true}
            label={Localized.Labels.rewards_app_survey_label}
            accessibilityLabel={questions[1]}
            accessibilityValue={{text: secondAnswer}}
            aria-label={questions[1]}
            aria-valuetext={secondAnswer}
            value={secondAnswer}
            multiline={true}
            numberOfLines={4}
            onChangeText={onChangeSecondAnswer}
            maxLength={140}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            returnKeyType={'done'}
            containerStyle={styles.textContainerStyle}
            contentStyle={styles.msgContentStyle}
            clearButtonMode="while-editing"
            textColor={'#111'}
            fontSize={Styles.Fonts.f8}
            labelStyle={[
              styles.msgLableViewTextStyle,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
            ]}
            outlineStyle={styles.msgLabelOutlineStyle}
            showShadow={Platform.OS === 'ios'}
          />

          <AVText
            style={[
              styles.payDescriptionCountLabel,
              getSnackDescriber().snackDetailsBtnFontSTyle(),
              secondAnswer.length === 140 && {
                color: Styles.Colors.Refive.deleteButton,
              },
            ]}
          >
            {secondAnswer.length + '/140'}
          </AVText>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  appSurveyView: {
    width: '100%',
  },
  inputLabelText: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '500',
    color: Styles.darkColor,
    marginTop: Styles.Spacing.m3,
    textAlign: 'center',
  },
  msgContentStyle: {
    paddingTop: Styles.Spacing.m2,
    paddingBottom: Styles.Spacing.m3,
    top: Styles.Spacing.m1,
    height: 130,
  },
  textContainerStyle: {
    width: '100%',
    marginTop: Styles.Spacing.m3,
    minHeight: 130,
    maxHeight: 150,
  },
  msgLableViewTextStyle: {
    fontSize: Styles.Fonts.f8,
    fontWeight: '400',
    color: Styles.Colors.PayNew.darkHuesBase04,
    marginBottom: Styles.Spacing.m1,
  },
  msgLabelOutlineStyle: {
    borderColor: Styles.inActiveDotColor,
    borderRadius: Styles.Spacing.m2,
    borderWidth: 1,
    elevation: Platform.OS === 'android' ? 2 : 0,
    backgroundColor: Styles.white,
  },
  payDescriptionCountLabel: {
    alignSelf: 'flex-end',
    marginTop: Styles.Spacing.m1,
    fontSize: Styles.Fonts.f8,
    color: Styles.Colors.PayLegacy.grayScaleBase03,
  },
});

export default RewardsAppSurvey;
